import { render, staticRenderFns } from "./ExtensionButtons.vue?vue&type=template&id=7d88c272&scoped=true&"
import script from "./ExtensionButtons.vue?vue&type=script&lang=js&"
export * from "./ExtensionButtons.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionButtons.vue?vue&type=style&index=0&id=7d88c272&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d88c272",
  null
  
)

export default component.exports